import React, { useState, useEffect, createContext } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Contact from './components/Contact';
import ThemeToggle from './components/ThemeToggle';
import './index.css';

export const ThemeContext = createContext();

function App() {
  const [isDarkMode, setIsDarkMode] = useState(true);

  useEffect(() => {
    document.body.classList.toggle('dark-mode', isDarkMode);
  }, [isDarkMode]);

  const toggleTheme = () => setIsDarkMode(prev => !prev);

  return (
    <ThemeContext.Provider value={{ isDarkMode, toggleTheme }}>
      <div className="App">
        {/* Animated floating orbs background */}
        <div className="animated-bg">
          <div className="orb orb-1" />
          <div className="orb orb-2" />
          <div className="orb orb-3" />
          <div className="orb orb-4" />
        </div>

        <Navbar />
        <ThemeToggle />
        <Hero />
        <About />
        <Projects />
        <Contact />

        <footer className="footer">
          <div className="footer-line" />
          <p>Designed & Built by Kotresh C &bull; {new Date().getFullYear()}</p>
        </footer>
      </div>
    </ThemeContext.Provider>
  );
}

export default App;
